
(function () {
  /**
   * GENM Promotion 2: PeaceMakers' Paths free gift.
   * Promotion dates: October 23-31, 2026.
   * Qualifying product: Digital Calming Corner & Time-In ToolKit
   * across all six language variants.
   *
   * Add one gift when at least one qualifying variant is in the cart.
   * Remove only gifts added by this script when no qualifying
   * variants remain in the cart.
   * Refresh the cart UI after cart changes.
   */

  const TOOLKIT_VARIANT_IDS = [
    42831904211009,
    42831904243777,
    42831904276545,
    42831904309313,
    42831904342081,
    42831904374849
  ];

  const GIFT_VARIANT_ID = 50653904764993;
  const GIFT_PROPERTY = '_genm_peacemakers_gift';
  const GIFT_PROPERTY_VALUE = 'true';
  const CHECK_INTERVAL = 2500;

  let reconciling = false;
  let reconcileAgain = false;
  let refreshingCartUI = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Could not read Shopify cart.');
    }

    return response.json();
  }

  async function addGift() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: GIFT_PROPERTY_VALUE
          }
        }]
      })
    });

    if (!response.ok) {
      throw new Error(
        'Could not add PeaceMakers gift: ' + await response.text()
      );
    }

    return response.json();
  }

  async function updateQuantities(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error('Could not update PeaceMakers gift in cart.');
    }

    return response.json();
  }

  function isScriptAddedGift(item) {
    return Number(item.variant_id) === GIFT_VARIANT_ID &&
      item.properties &&
      item.properties[GIFT_PROPERTY] === GIFT_PROPERTY_VALUE;
  }

  function announceCartChange(eventName) {
    document.dispatchEvent(new CustomEvent(eventName));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('genm:cart-changed'));
  }

  async function refreshCartUI() {
    if (refreshingCartUI) return;
    refreshingCartUI = true;

    try {
      announceCartChange('genm:peacemakers-cart-refresh');

      const cart = await getCart();

      document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble span, .cart-count, [data-cart-item-count]'
      ).forEach(function (element) {
        if (element.matches('.visually-hidden')) {
          element.textContent = cart.item_count;
        } else if (element.hasAttribute('data-cart-count')) {
          element.textContent = cart.item_count;
        } else if (element.hasAttribute('data-cart-item-count')) {
          element.setAttribute('data-cart-item-count', cart.item_count);
        } else if (
          element.matches('.cart-count-bubble span, .cart-count')
        ) {
          element.textContent = cart.item_count;
        }
      });

      document.dispatchEvent(
        new CustomEvent('genm:peacemakers-cart-updated', {
          detail: { cart }
        })
      );
    } catch (error) {
      console.error('[GENM PeaceMakers Cart Refresh]', error);
    } finally {
      refreshingCartUI = false;
    }
  }

  async function reconcileGift() {
    if (reconciling) {
      reconcileAgain = true;
      return;
    }

    reconciling = true;
    let cartChanged = false;

    try {
      const cart = await getCart();

      const toolkitInCart = cart.items.some(function (item) {
        return TOOLKIT_VARIANT_IDS.includes(Number(item.variant_id)) &&
          item.quantity > 0;
      });

      const giftItems = cart.items.filter(isScriptAddedGift);

      if (toolkitInCart && giftItems.length === 0) {
        await addGift();
        cartChanged = true;

        document.dispatchEvent(
          new CustomEvent('genm:peacemakers-gift-added')
        );
      } else if (!toolkitInCart && giftItems.length > 0) {
        const updates = {};

        giftItems.forEach(function (item) {
          updates[item.key] = 0;
        });

        await updateQuantities(updates);
        cartChanged = true;

        document.dispatchEvent(
          new CustomEvent('genm:peacemakers-gift-removed')
        );
      } else if (toolkitInCart && giftItems.length > 1) {
        const updates = {};

        giftItems.slice(1).forEach(function (item) {
          updates[item.key] = 0;
        });

        await updateQuantities(updates);
        cartChanged = true;
      } else if (
        toolkitInCart &&
        giftItems.length === 1 &&
        giftItems[0].quantity !== 1
      ) {
        const updates = {};
        updates[giftItems[0].key] = 1;

        await updateQuantities(updates);
        cartChanged = true;
      }

      if (cartChanged) {
        await refreshCartUI();
      }
    } catch (error) {
      console.error('[GENM PeaceMakers Free Gift]', error);
    } finally {
      reconciling = false;

      if (reconcileAgain) {
        reconcileAgain = false;
        window.setTimeout(reconcileGift, 150);
      }
    }
  }

  function scheduleReconcile() {
    window.setTimeout(reconcileGift, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileGift, {
      once: true
    });
  } else {
    reconcileGift();
  }

  window.setInterval(reconcileGift, CHECK_INTERVAL);

  document.addEventListener('submit', scheduleReconcile, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest(
      'form[action*="/cart/add"], button[name="add"], [name="add"], ' +
      '.quantity__button, cart-remove-button, [data-cart-remove], ' +
      'a[href*="/cart/change"]'
    )) {
      scheduleReconcile();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches(
      'input[name="quantity"], select[name="quantity"], quantity-input input'
    )) {
      scheduleReconcile();
    }
  }, true);

  [
    'cart:updated',
    'cart:refresh',
    'cart-drawer:refresh',
    'product:added',
    'ajaxProduct:added'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleReconcile);
  });
})();
